import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '../Skeleton';
export default function RadioSkeleton({ variant }) {
    return (_jsxs(_Fragment, { children: [_jsx("div", { "data-testid": "radio-skeleton", children: _jsx(Skeleton, { height: variant, width: variant, type: "circle" }) }), _jsx(Skeleton, { width: "200px", height: "24px" })] }));
}
//# sourceMappingURL=Skeleton.js.map